function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    //A boolean option is the default
    options: {
      type: Object,
      "default": function _default() {
        return {
          "true": true,
          "false": false
        };
      }
    },
    value: {
      "default": true
    },
    disabled: {
      type: Boolean,
      "default": false
    }
  },
  created: function created() {
    this.$store.commit('elements/setDefaultOption', {
      name: this.name,
      value: this.value
    });
  },
  computed: _objectSpread({}, mapState({
    globalOptions: function globalOptions(s) {
      return s.elements.globalOptions;
    }
  }), {
    selected: {
      get: function get() {
        return this.$store.state.elements.globalOptions[this.name];
      },
      set: function set(v) {
        this.$store.commit('elements/setGlobalOption', {
          name: this.name,
          value: v
        });
      }
    },
    isDisabled: function isDisabled() {
      var selected = Object.values(this.globalOptions).filter(function (v) {
        return v;
      }).length;
      return this.disabled || !this.globalOptions[this.name] && selected >= this.$ncsConfig.elements.maximum_field_options;
    }
  })
};